import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Table, Alert } from 'react-bootstrap';
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import OrderDetailModal from './OrderDetailModal';
import Select from "react-select";
import OrderDetailModalParent from './OrderDetailModalParent';
import moment from 'moment';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import { useAppContext } from 'providers/AppProvider';
import SetMastersDetails from 'components/common/SetMastersDetails';
import Breadcrumb from 'components/doc-components/Breadcrumb';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import DatePicker from 'react-datepicker';
import RemoveMasters from 'components/common/RemoveMasters';
import TopSummaryBar from 'components/order-history/TopSummaryBar';
import paths from 'routes/paths';
import { storeList, getStoredStoreId, setStoredStoreId } from 'components/common/StoreList';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import AddOrderDetailModal from 'components/order-history/AddOrderDetailModal';

const OrderDetails = () => {
  const [refreshOrder, setRefreshOrder] = useState(false);
  const [facility, setFacility] = useState(null);
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]); // Data from the API
  const [filteredData, setFilteredData] = useState([]); // Filtered data to display
  const [errorMessage, setErrorMessage] = useState(true);
  const [storeOptions] = useState([{ key: "All Stores", value: "" }, ...storeList]);
  const [isLoading, setIsLoading] = useState(true);
  const [apiError, setApiError] = useState(false);
  const [topData , setTopData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const savedStoreId = getStoredStoreId();
  const initialStoreOption = storeOptions.find(opt => String(opt.value) === String(savedStoreId)) || null;
  const [selectedStoreValue, setSelectedStoreValue] = useState(initialStoreOption);
  const searchParams = new URLSearchParams(location.search);
  const currentTitle = searchParams.get('id');
  const [filters, setFilters] = useState({
    startDate: moment().subtract(1, 'months').startOf('day').format('MM/DD/YYYY'),
    endDate: moment().endOf('day').format('MM/DD/YYYY'),
    patient: '',
    rxNumber: '',
    category: (currentTitle === 'is_callback' || currentTitle === 'is_pharmacy_attention') ? '' : currentTitle || '',
    facility_ID: '',
    store: savedStoreId,
    initiated: '',
    callback: currentTitle === 'is_callback' ? '1' : '0',
    pharmacyAttention: currentTitle === 'is_pharmacy_attention' ? '1' : '0',
  });
  const {
    config: { isNavbarVerticalCollapsed },
    setConfig
  } = useAppContext();
  const orderStatus = localStorage.getItem("order_status")
  ? JSON.parse(localStorage.getItem("order_status"))
  : {}; 
  const facilityList = JSON.parse(localStorage.getItem("facilitiesData"));
  const [options] = useState([
    { value: '', key: 'All' },
    ...facilityList
  ]);

  let facilityObj = facilityList.reduce((obj, item) => {
    obj[item.value] = item.key;
    return obj;
  }, {})

  const columns = [
    {
      accessorKey: 'patient',
      header: 'Patient',
      meta: {
        headerProps: { className: 'text-900 text-start px-2' },
        cellProps: { className: 'text-start px-2' }
      }
    },
    {
      accessorKey: 'facility',
      header: 'Facility',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      }
    },
    {
      accessorKey: 'ordertypetable',
      header: 'Order Type',
      meta: {
        headerProps: { className: 'text-900 text-center' },
        cellProps: { className: 'text-center' }
      },
    },
    {
      accessorKey: 'drug',
      header: 'Drug',
      meta: {
        headerProps: { className: 'text-900 text-start px-2' },
        cellProps: { className: 'text-start px-2' }
      }
    },

    {
      accessorKey: 'reasonLabels',
      header: 'Reason',
      meta: {
        headerProps: { className: 'text-900 text-start px-2' },
        cellProps: { className: 'text-start px-2' }
      }
    },
    {
      accessorKey: 'deliverydatetime',
      header: 'Delivery-Date',
      meta: {
        headerProps: { className: 'text-900 text-center px-2' },
        cellProps: { className: 'text-center fw-bold px-2' }
      },
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.delivery_date ? moment(rowA.original.delivery_date) : moment(0);
        const b = rowB.original.delivery_date ? moment(rowB.original.delivery_date) : moment(0);
        return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
      }
    },
    {
      accessorKey: 'orderstatus',
      header: 'Order Status',
      meta: {
        headerProps: { className: 'text-900 text-center px-2' },
        cellProps: { className: 'text-center px-2' }
      },
      cell: ({ row: { original } }) => {
        const orderStatus = JSON.parse(localStorage.getItem("order_status"));
        return (
          <Link onClick={() => { setShow(true) }} state={{ original }}>
            {Number(original.is_pa) === 1
              ? "PA"
              : Number(original.is_billing_issue) === 1
              ? "Billing Issue"
              : Number(original.is_discarded) === 1
              ? "Discarded"
              : Number(original.is_loansupplies) === 1
              ? "Loan Supplies"
              : orderStatus[original.orderstatus]}

          </Link>
        )
      }
    },
    // {
    //   accessorKey: 'reason',
    //   header: 'Reason',
    //   meta: {
    //     headerProps: { className: 'text-900 text-start' },
    //     cellProps: { className: 'text-start' }
    //   }
    // },
    // {
    //   accessorKey: 'refillrequest',
    //   header: 'Refill Request',
    //   meta: {
    //     headerProps: { className: 'text-900 text-start' },
    //     cellProps: { className: 'text-start' }
    //   }
    // },
    {
      accessorKey: 'createddate',
      header: 'Created Date',
      meta: {
        headerProps: { className: 'text-900 text-start' },
        cellProps: { className: 'text-start' }
      },
      sortingFn: (rowA, rowB) => {
        const a = rowA.original.createddate
          ? moment(rowA.original.createddate, 'MM/DD/YY - hh:mm A')
          : moment(0);
        const b = rowB.original.createddate
          ? moment(rowB.original.createddate, 'MM/DD/YY - hh:mm A')
          : moment(0);
        return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
      }
    },
    // {
    //   accessorKey: 'moredetails',
    //   header: 'More Details',
    //   meta: {
    //     headerProps: { className: 'text-900 text-start' },
    //   },
    //   cell: () => {
    //     return (
    //       <FontAwesomeIcon icon="file" className="me-1 fs-11" />
    //     )
    //   }
    // },
  ]

  const applyCategoryFilter = (sourceData, category) => {
    const today = moment();

    switch (category) {
      case 'discard':
        return sourceData.filter(item => Number(item.is_discarded) === 1);
      case 'billing':
        return sourceData.filter(item => Number(item.is_billing_issue) === 1);
      case 'mobile':
        return sourceData.filter(
          item =>
            Number(item.orderstatus) === 1 &&
            Number(item.is_billing_issue) !== 1 &&
            Number(item.is_discarded) !== 1 &&
            Number(item.is_loansupplies) !== 1 &&
            Number(item.is_pa) !== 1 &&
            Number(item.is_hold) !== 1
        );
      case 'pa':
        return sourceData.filter(item => Number(item.is_pa) === 1);
      case 'loan':
        return sourceData.filter(item => Number(item.is_loansupplies) === 1);
      case 'hold':
        return sourceData.filter(item => Number(item.is_hold) === 1);
      case 'done':
        return sourceData.filter(item => Number(item.orderstatus) === 9);
      case 'due':
        return sourceData.filter(
          item =>
            Number(item.orderstatus) < 8 &&
            moment(item.delivery_date).isSameOrBefore(today, 'day')
        );
      case 'task':
        return sourceData.filter(item => Number(item.orderstatus) === 99);
      default:
        return sourceData;
    }
  };

  const applyLocalFilters = (sourceData, currentFilters) => {
    let filtered = applyCategoryFilter(sourceData, currentFilters.category);

    filtered = filtered.filter(item => {
      return (
        (!currentFilters.patient ||
          item.patient.toLowerCase().includes(currentFilters.patient.toLowerCase())) &&
        (!currentFilters.rxNumber ||
          String(item.rxnumber || '').includes(currentFilters.rxNumber.trim())) &&
        (!currentFilters.facility_ID ||
          Number(item.facilityid) === Number(currentFilters.facility_ID)) &&
        (!currentFilters.initiated ||
          !item.initiated ||
          item.initiated === currentFilters.initiated) &&
        (!currentFilters.store ||
          Number(item.store_id) === Number(currentFilters.store)) &&

        (currentFilters.callback !== '1' ||
          (Number(item.is_callback) === Number(currentFilters.callback) && (Number(item.orderstatus) < 9 || Number(item.orderstatus) == 99))) &&

        (currentFilters.pharmacyAttention !== '1' ||
          (Number(item.is_pharmacy_attention) === Number(currentFilters.pharmacyAttention) && (Number(item.orderstatus) < 9 || Number(item.orderstatus) == 99)))
      );
    });

    return filtered;
  };

  const fetchTable = async () => {
    setIsLoading(true);
    setApiError(false);
    const searchParams = new URLSearchParams(location.search);
    let sendingObj = {
      from_date: searchParams.get('from') || filters.startDate,
      to_date: searchParams.get('to') || filters.endDate,
    }
    let tokenStr = localStorage.getItem("accessToken");
    try{
    const { data } = await axios.post(`${process.env.REACT_APP_SERVER_URL}` + "/orders/list-orders/", sendingObj, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
    let orderType = JSON.parse(localStorage.getItem("order_types"));
    let objData = data.orders
    let results = []
    objData.map((iterator) => {
      results.push({
        patient: iterator.patient_lastname + ", " + iterator.patient_firstname,
        facility: facilityObj[iterator.facility_id],
        facilityid: iterator.facility_id,
        ordertype: iterator.order_type,
        ordertypetable: iterator.order_type == 9 ? "New Patient" : orderType[iterator.order_type],
        deliverydatetime: (iterator.delivery_date != null && iterator.delivery_date != '') ? moment(iterator.delivery_date).format('MM/DD/YY') : null,
        reason: iterator.discarded_reason,
        reasonLabels: iterator.callback_reason_name || iterator.pharmacy_attention_reason_name,
        refillrequest: iterator.refill_request,
        createdby: iterator.created_by_username,
        // initiated: iterator.initiated || iterator.initiated_by || iterator.order_from_label || '',
        createddate: iterator.created != null ? moment(iterator.created).format('MM/DD/YY - hh:mm A') : null,
        orderstatus: iterator.order_status,
        rxnumber: iterator.pharmacy_order_id,
        qty: iterator.drug_qty,
        drug: [iterator.drug]
          .filter(val => val !== null && val !== undefined && val !== "")
          .join(" "),
        orderid: iterator.id,
        notesObj: iterator.notes,
        documents : iterator.documents,
        internalNotesObj: iterator.internal_notes,
        is_billing_issue: iterator.is_billing_issue,
        is_loansupplies: iterator.is_loansupplies,
        is_pa: iterator.is_pa,
        flag: true,
        patientModalData: iterator.patient,
        order_status_log : iterator.logs,
        is_notified: iterator.is_notified,
        is_hold: iterator.is_hold,
        holdreason_id: iterator.holdreason_id,
        holdreason_text: iterator.holdreason_text,
        hold_date: iterator.hold_date,
        hold_by_username: iterator.hold_by,
        // Units held on the Rx (null = not recorded). `qty` above is the order's drug_qty.
        hold_qty: iterator.hold_qty ?? null,
        is_discarded: iterator.is_discarded,
        delivery_date: iterator.delivery_date,
        store_id: iterator.facility_store_id,
        deliveryOn : iterator.delivery_type,
        pickup_store_id : iterator.pickup_store_id,
        billing_date: iterator.billing_date,
        billing_status  : iterator.billing_status,
        billing_timestamp : iterator.billing_timestamp,
        pv1_timestamp : iterator.pv1_timestamp,
        pv2_timestamp : iterator.pv2_timestamp,
        filling_timestamp : iterator.filling_timestamp,
        is_callback: iterator.is_callback,
        is_pharmacy_attention: iterator.is_pharmacy_attention,
        pharmacy_attention_id: iterator.pharmacy_attention_id,
        callback_master_id: iterator.callback_master_id,
        callback_number: iterator.callback_number,
        pharmacy_attention_reason_name: iterator.pharmacy_attention_reason_name,
        callback_reason_name: iterator.callback_reason_name,
        // note: iterator.note,
      })
    })

    results.sort((a, b) => {
      const dateA = a.delivery_date ? moment(a.delivery_date) : moment(0);
      const dateB = b.delivery_date ? moment(b.delivery_date) : moment(0);
      return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
    });

    setData(results);
    setFilteredData(applyLocalFilters(results, filters));
    setTopData(data.orders_status_count);
  } catch (error) {
    console.error('Error fetching data:', error);
    setApiError(true);
    toast.error("Failed to fetch order details.");
  } finally {
    setIsLoading(false);
  }
  }

  const searchByDate = async () => {
    try {
      await fetchTable();
      // clearFilters();
    } catch (error) {
      console.error('Error fetching data by date:', error);
      toast.error('Failed to fetch data by date');
    }
  };

  const table = useAdvanceTable({
    data: filteredData,
    columns,
    selection: false,
    sortable: true,
    pagination: true,
    initialState: {
      sorting: [{ id: 'deliverydatetime', desc: false }]
    }
  });

  useEffect(() => {
    setFilteredData(applyLocalFilters(data, filters));
  }, [data, filters]);

  useEffect(() => {
    setConfig('isNavbarVerticalCollapsed', true);
    fetchData();

    return () => {
      setConfig('isNavbarVerticalCollapsed', false);
      RemoveMasters();
    }
  }, [refreshOrder]);



  const fetchData = async () => {
    try {
      SetMastersDetails();
      fetchTable();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Remove query params on any field change
    navigate(`${location.pathname}`);
    setFilters({
      ...filters,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleFacilityInputChange = (selectedOption) => {
    setFacility(selectedOption);
    setFilters({
      ...filters,
      "facility_ID": selectedOption ? selectedOption.value : ''
    });
  }

  useEffect(() => {
    SetMastersDetails()
    return () => {
      RemoveMasters();
    };
  }, []);

  async function handleSearch(e) {
    e.preventDefault();
    if (filters.startDate && filters.endDate) {
      await searchByDate();
    }
  };
  const validateExpiryDate = date => {
    if (moment(date) > moment(filters.startDate)) {
      handleInputChange({ target: { name: 'endDate', value: moment(date).format("MM/DD/YYYY") } })
    } else {
      toast.error("End date should be greater than Start Date");
    }
  }

  function toCapitalCase(str) {
    if(str == 'pa') return 'PA';
    else return str?.charAt(0)?.toUpperCase() + str?.slice(1) || '';
  }

  const addOrderModal = () => {
    setShowModal(true);
  };

  function clearFilters (){
    setStoredStoreId('');
    setFilters(prev => ({
      ...prev,
      patient: '',
      rxNumber: '',
      category: '',
      facility_ID: '',
      store: '',
      initiated: ''
    }));
    setSelectedStoreValue(null);
    setFacility(null);
  }

  const breadcrumbItems = [
    { name: 'Dashboard', href: '/main', isActive: false },
    { name: 'Order', href: '#', isActive: true },
    { name: 'Order List', href: "#", isActive: true }
  ];

  const handleStoreChange = (selectedOption) => {
    const storeVal = selectedOption ? selectedOption.value : '';
    setStoredStoreId(storeVal);
    setFilters(prev => ({
      ...prev,
      "store": storeVal
    }));
    setSelectedStoreValue(selectedOption);
  }

  return (
    <>
      {showModal && <AddOrderDetailModal show={showModal} setShow={setShowModal} />}
      <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
      <OrderDetailModalParent show={show} filteredData={filteredData} setRefresh={setFilteredData} handleClose={() => setShow(false)} setOrder={setRefreshOrder} />
      {/* <Card className="p-1 pt-3 pb-1">
        <Row>
          <TopSummaryBar stats={topData} />
        </Row>
      </Card> */}
      <Card className="p-3">
        <h4 className="mb-3">{currentTitle == 'is_callback' ? 'Callback' : currentTitle == 'is_pharmacy_attention' ? 'Pharmacy Attention' : toCapitalCase(currentTitle)} Order List</h4>
        <div className="border rounded p-3 pb-4 mb-4">
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Start Date:</Form.Label>
                <DatePicker
                  placeholderText="mm/dd/yy"
                  className="form-control"
                  selected={filters.startDate ? moment(filters.startDate).format("MM/DD/YYYY") : null}
                  onChange={(date) =>
                    handleInputChange({ target: { name: 'startDate', value: moment(date).format("MM/DD/YYYY") } })
                  }
                  dateFormat="MM/dd/yy"
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>End Date:</Form.Label>
                <DatePicker
                  placeholderText="mm/dd/yy"
                  className="form-control"
                  selected={filters.endDate ? moment(filters.endDate).format("MM/DD/YYYY") : null}
                  onChange={(date) =>
                    validateExpiryDate(date)
                  }
                  dateFormat="MM/dd/yy"
                />
              </Form.Group>
            </Col>
            <Col md="auto" className="d-flex align-items-end">
              <Button variant="primary" onClick={handleSearch}>
                Search
              </Button>
            </Col>
            <Col className="d-flex align-items-end justify-content-end ms-auto">
              <Button onClick={addOrderModal}>Add Order</Button>
            </Col>
          </Row>
        </div>
        <div className="filters-section border rounded pt-4 p-3 position-relative">
  <div className="filter-heading">Filters</div>
  
  <Row className="mb-3">

    <Col md={4}>
      <Form.Group>
        <Form.Label>Store</Form.Label>
        <ThemedSelect
          name="store"
          closeMenuOnSelect
          placeholder="Select store"
          classNamePrefix="react-select"
          options={storeOptions}
          value={selectedStoreValue}
          getOptionLabel={option => option.key}
          getOptionValue={option => option.value}
          onChange={handleStoreChange}
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: state.isFocused ? "#80bdff" : "#ced4da",
              boxShadow: "none",
              '&:hover': { borderColor: "#80bdff" },
              minHeight: "38px"
            }),
            option: (base, { isFocused, isSelected }) => ({
              ...base,
              backgroundColor: isSelected
                ? "#e9ecef"
                : isFocused
                ? "#f8f9fa"
                : "#fff",
              color: "#212529",
              cursor: "pointer"
            }),
            singleValue: base => ({
              ...base,
              color: "#212529"
            }),
            placeholder: base => ({
              ...base,
              color: "#6c757d"
            }),
            menu: base => ({
              ...base,
              zIndex: 9999
            })
          }}
        />
      </Form.Group>
    </Col>

    <Col md={4}>
      <Form.Group>
        <Form.Label>Facility</Form.Label>
        <Select
          name="facility"
          closeMenuOnSelect
          placeholder="Select Facility"
          classNamePrefix="react-select"
          options={options}
          getOptionLabel={option => option.key}
          getOptionValue={option => option.value}
          onChange={handleFacilityInputChange}
          value={facility}
        />
      </Form.Group>
    </Col>


    <Col md={4}>
      <Form.Group>
        <Form.Label>Initiated</Form.Label>
        <Form.Select
          name="initiated"
          value={filters.initiated}
          onChange={handleInputChange}
        >
          <option value="">All</option>
          <option value="Pharmacy">Pharmacy</option>
          <option value="Facility">Facility</option>
        </Form.Select>
      </Form.Group>
    </Col>


  </Row>

          <Row className="g-3">


            <Col md={4}>
              <Form.Group>
                <Form.Label>Patient</Form.Label>
                <Form.Control
                  type="text"
                  name="patient"
                  placeholder="Search by patient"
                  value={filters.patient}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Rx Number</Form.Label>
                <Form.Control
                  type="text"
                  name="rxNumber"
                  placeholder="Search by Rx"
                  value={filters.rxNumber}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Col>


            <Col md={4} className='mb-2'>
              <Form.Group>
                <Form.Label>Category</Form.Label>
                <Form.Select
                  name="category"
                  value={filters.category}
                  onChange={handleInputChange}
                >
                  <option value="">All</option>
                  <option value="discard">Discarded Order</option>
                  <option value="billing">Billing Issue</option>
                  <option value="mobile">Mobile Order</option>
                  <option value="pa">PA</option>
                  <option value="loan">Loan Supplies</option>
                  <option value="done">Done</option>
                  <option value="due">Due</option>
                  <option value="task">Task</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Check
                  type="switch"
                  label="Callback"
                  checked={filters.callback === "1"}
                  onChange={(e) => {
                    navigate(`${location.pathname}`);
                    setFilters({
                      ...filters,
                      callback: e.target.checked ? "1" : "0"
                    })
                  }}
                />
              </Form.Group>
            </Col>
             <Col md={4}>
              <Form.Group>
                <Form.Check
                  type="switch"
                  label="Pharmacy Attention"
                  checked={filters.pharmacyAttention === "1"}
                  onChange={(e) => {
                    navigate(`${location.pathname}`);
                    setFilters({
                      ...filters,
                      pharmacyAttention: e.target.checked ? "1" : "0"
                    })
                  }}
                />
              </Form.Group>
            </Col>


          </Row>
</div>

      </Card>
      <br></br>
      {isLoading ? (
        <ShimmerUI />
      ) : apiError ? (
        <Alert variant="danger" className="text-center fw-bold">
          Failed to fetch order details. Please try again later.
        </Alert>
      ) : filteredData.length === 0 ? (
        <Alert variant="info" className="text-center fw-bold">
          No order details found for the selected date range.
        </Alert>
      ) : (
        <Card className="p-3">
          <AdvanceTableProvider {...table}>
            <Row>
              <Col xs="12">
                <AdvanceTable
                  headerClassName="bg-200 text-nowrap align-middle text-center"
                  rowClassName="text-nowrap align-middle text-center"
                  tableProps={{
                    size: 'sm',
                    striped: true,
                    className: 'fs-10 mb-0 overflow-hidden'
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Card.Footer>
                <div className="mt-3">
                  <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
                </div>
              </Card.Footer>
            </Row>
          </AdvanceTableProvider>
        </Card>
      )}
    </>
  );
};

export default OrderDetails;
